// removed by extract-text-webpack-plugin
module.exports = {"App":"_1o-FpbQrR11SDFN-G7O4U3","Main":"MCIv-XjDrRCtte1VpGMw7","Content":"_1RCPTOaJXgLzkcYOPXXEg4","Container":"_2Y284CIvJgAH8pMR0RKHWH"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 922
// module chunks = 0